// Small, sober line-icon set (Feather/Lucide-style: 24x24 viewbox, stroke
// only) used across the sidebar instead of emoji. One shared component keeps
// every icon visually consistent (weight, corners, size).
const PATHS = {
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm9 2-4.9-4.9',
  view: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  layers: 'm12 3 9 5-9 5-9-5 9-5Zm-9 9 9 5 9-5M3 17l9 5 9-5',
  compass: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z M15.5 8.5l-2.2 5-5 2.2 2.2-5 5-2.2Z',
  grid: 'M4 4h7v7H4V4Zm9 0h7v7h-7V4ZM4 13h7v7H4v-7Zm9 0h7v7h-7v-7Z',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.5 2.4 4 5.6 4 9s-1.5 6.6-4 9c-2.5-2.4-4-5.6-4-9s1.5-6.6 4-9Z',
  palette: 'M12 21a9 9 0 0 1 0-18c4.5 0 8 3.1 8 6.8 0 2.1-1.6 3.7-3.6 3.7h-1.7c-1 0-1.7.9-1.4 1.9.2.5.3.9.3 1.4 0 1.4-.8 2.6-1.6 4.2ZM7.5 12a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm2.8-4.3a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm5.4.3a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Zm1.8 4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z',
  shield: 'M12 3l7 3.2v5.3c0 4.6-3 7.9-7 9.5-4-1.6-7-4.9-7-9.5V6.2L12 3Z',
  building: 'M6 21V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v16M9.5 8h1m4 0h1M9.5 12h1m4 0h1M9.5 16h1m4 0h1M3 21h18',
  filter: 'M4 5h16M7 12h10M11 19h2',
  chevronLeft: 'm14 6-6 6 6 6',
  chevronRight: 'm10 6 6 6-6 6',
  chevronDown: 'm6 9 6 6 6-6',
  chevronUp: 'm18 15-6-6-6 6',
  menu: 'M4 6h16M4 12h16M4 18h16',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-9.5v4.5m0-8v.01',
  warning: 'M10.6 3.9 2.4 18a1 1 0 0 0 .9 1.5h17.4a1 1 0 0 0 .9-1.5L13.4 3.9a1 1 0 0 0-1.8 0ZM12 9.5v4m0 2.7v.01',
  trash: 'M4 7h16M9.5 7V4.5h5V7m-7.5 0 1 13h8l1-13',
  image: 'M4 5h16v14H4V5Zm3.5 10.5 3.5-4 3 2.8L17.5 11l1.5 3.5H7.5Z M8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  save: 'M5 4h11l3 3v13H5V4Zm3 0v5h8V4M8 14h8v6H8v-6Z',
  folderOpen: 'M3 8V5.5a1 1 0 0 1 1-1h4.8l1.8 2H19a1 1 0 0 1 1 1V8M3 8h18l-1.8 10.5a1 1 0 0 1-1 .8H5.8a1 1 0 0 1-1-.8L3 8Z',
  undo: 'M9 7 4 12l5 5M4 12h11a5 5 0 0 1 0 10h-1',
  close: 'm6 6 12 12M18 6 6 18',
  check: 'm5 12 5 5 9-9',
  edit: 'M4 20h4l10.5-10.5a2.1 2.1 0 0 0-3-3L5 17v3ZM13 6l3 3',
  lock: 'M6.5 11V8a5.5 5.5 0 1 1 11 0v3M5 11h14v9H5v-9Z',
  link: 'M9 15l6-6M8.5 8.5 11 6a3.5 3.5 0 0 1 5 5l-2 2M15.5 15.5 13 18a3.5 3.5 0 0 1-5-5l2-2',
  // Two branches converging into one stem — the tronçon merge.
  merge: 'M6 4v3a5 5 0 0 0 5 5h2a5 5 0 0 0 5-5V4M12 12v8m0 0 3-3m-3 3-3-3',
  crosshair: 'M12 3v3m0 12v3M3 12h3m12 0h3M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z',
  swords: 'm5 4 15 15M4 19l4-1 11-11-3-3L5 15l-1 4Zm14-15 1 4-4-1',
  home: 'M4 11 12 4l8 7v9a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1v-9Z',
  discord: 'M8 9c1.5-1 3-1.4 4-1.4s2.5.4 4 1.4M8.3 16c2.2 1 5.2 1 7.4 0M6.5 6.5C4 8 3.5 12.5 4 16c1 1.5 3 2.5 5 3l1-2M17.5 6.5C20 8 20.5 12.5 20 16c-1 1.5-3 2.5-5 3l-1-2M9 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
}

const Icon = ({ name, size = 15, className = '', ...rest }) => {
  const d = PATHS[name]
  if (!d) return null
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`icon ${className}`}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={d} />
    </svg>
  )
}

export default Icon
